// CNC 파트너 — 케이스(전체 이력·검색) (2026-10-23, UI 구조 단계)
import React, { useState } from 'react';
import { Package } from 'lucide-react';
import PageHeader from '../common/PageHeader';
import { SAMPLE_LABS, makeSampleCases } from './partnerSample';
import { useIsMobile, SampleNotice, ui } from './partnerUi';
import PartnerCaseBoard from './PartnerCaseBoard';

function PartnerCases() {
    const mobile = useIsMobile();
    const [cases, setCases] = useState(makeSampleCases);
    return (
        <div>
            <PageHeader icon={Package} title={'케이스'} subtitle={'받은 케이스 전체 이력을 검색하고 상태를 바꿉니다.'} />
            <div style={mobile ? ui.bodyMobile : ui.body}>
                <SampleNotice />
                <PartnerCaseBoard cases={cases} setCases={setCases} labs={SAMPLE_LABS} showPeriod mobile={mobile} />
            </div>
        </div>
    );
}

export default PartnerCases;
